import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion.create(Box);

const bigCubeVariants = {
    initial: {
        scale: 1,
        rotate: 0,
    },
    animate: {
        scale: [1, 1.1, 1],
        rotate: [0, 180, 360],
        transition: {
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
        }
    }
};

const smallCubeVariants = {
    initial: (i: number) => ({
        x: 0,
        y: 0,
        opacity: 0,
        scale: 0
    }),
    animate: (i: number) => {
        const angle = (i * 360) / 8;
        const radius = 50;
        
        return {
            x: Math.cos(angle * (Math.PI / 180)) * radius,
            y: Math.sin(angle * (Math.PI / 180)) * radius,
            opacity: [0, 1, 0],
            scale: [0, 1, 0],
            transition: {
                duration: 2,
                repeat: Infinity,
                delay: i * 0.1,
                ease: "easeInOut"
            }
        };
    }
};

const BrokenCubesAnimation = () => {
    const smallCubes = Array.from({ length: 8 }, (_, i) => i);

    return (
        <Box 
            position="relative" 
            width="120px" 
            height="120px"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <motion.div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                {/* Большой кубик */}
                <MotionBox
                    position="absolute"
                    width="40px"
                    height="40px"
                    bg="red.500"
                    variants={bigCubeVariants}
                    initial="initial"
                    animate="animate"
                />
                
                {/* Маленькие кубики */}
                {smallCubes.map((i) => (
                    <motion.div
                        key={i}
                        style={{
                            position: 'absolute',
                            width: '10px',
                            height: '10px',
                            backgroundColor: '#FC8181',
                            borderRadius: '2px'
                        }}
                        variants={smallCubeVariants}
                        initial="initial"
                        animate="animate"
                        custom={i}
                    />
                ))}
            </motion.div>
        </Box>
    );
};

export default BrokenCubesAnimation; 